var Anhui = "안후이";
var Beijing = "베이징";
var Chongqing = "충칭";
var Fujian = "푸젠";
var Gansu = "간쑤";
var Guangdong = "광둥";
var Guangxi = "광시";
var Guizhou = "구이저우";
var Hainan = "하이난";
var Hebei = "허베이";
var Heilongjiang = "헤이룽장";
var Henan = "허난";
var Hubei = "후베이";
var Hunan = "후난";
var Jiangsu = "장쑤";
var Jiangxi = "장시";
var Jilin = "지린";
var Liaoning = "랴오닝";
var Ningxia = "닝샤";
var Qinghai = "칭하이";
var Shaanxi = "산시";
var Shandong = "산둥";
var Shanghai = "상하이";
var Shanxi = "산시";
var Sichuan = "쓰촨";
var Tianjin = "톈진";
var Tibet = "티베트";
var Xinjiang = "신장";
var Yunnan = "윈난";
var Zhejiang = "저장";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "내몽골",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
